import apiClient from '../../../api/client';

export interface ReceiptVersion {
  id: number;
  numero: number;
  tipo: 'INICIAL' | 'ACTUALIZADA';
  esReconstruccion: boolean;
  etiquetaReconstruccion: string | null;
  formato: number;
  capturadoEn: string;
  emitidoEn: string;
  emitidoPor: string;
  pdfSha256: string;
  bytes: number;
}

export interface ReceiptVersionHistory {
  idPago: number;
  estadoPago: 'VIGENTE' | 'ANULADO';
  fechaAnulacion: string | null;
  versiones: ReceiptVersion[];
  actualizacion: {
    elegible: boolean;
    codigo:
      | 'PRIMERA_VERSION'
      | 'CAMBIOS_FINANCIEROS'
      | 'SIN_CAMBIOS'
      | 'PAGO_ANULADO_SIN_RECIBO'
      | 'SIN_APLICACIONES';
    motivo: string;
  };
}

/** Read-only history lookup: opening the version manager never issues a PDF. */
export async function listarVersionesRecibo(idPago: number): Promise<ReceiptVersionHistory> {
  const { data } = await apiClient.get<ReceiptVersionHistory>(
    `/admin/pagos/${idPago}/recibo/versiones`,
  );
  return data;
}

/** Explicit document issuance; never creates or reallocates a payment. */
export async function emitirVersionRecibo(idPago: number): Promise<{ version: ReceiptVersion }> {
  const { data } = await apiClient.post<{ version: ReceiptVersion }>(
    `/admin/pagos/${idPago}/recibo/versiones`,
  );
  return data;
}
